import { AsyncAutocompleteFetchAdapter } from "../AutocompleteRoot";
import { ProductForSelection } from "./AutcompleteProductTypes";
import _ from "lodash";
import axios from "axios";

const fetchCache: Map<string, ProductForSelection[]> = new Map();

export class LegacyAutocompleteProductFetch implements AsyncAutocompleteFetchAdapter<ProductForSelection> {
  constructor(private async_url: string) {
    const requiredFieldsInUrl = ["label", "value", "is_actief", "blocked", "naam", "snaam", "prijs"];
    const missingFields = requiredFieldsInUrl.filter((field) => !async_url.includes(field));
    if (missingFields.length > 0) {
      throw new Error(`Url is missing the following required product properties: ${missingFields.join(", ")}`);
    }
  }

  async fetchInitialValue(
    id: number | string | number[] | string[]
  ): Promise<ProductForSelection[] | ProductForSelection | undefined> {
    if (typeof id !== "number" && id.length === 0) {
      return;
    }
    const response = await axios.post(this.async_url, [
      {
        field: "id",
        operator: Number.isFinite(id) ? "=" : "in",
        value: id,
      },
    ]);
    if (typeof id === "number" || typeof id === "string") {
      return response.data.data.data[0];
    } else if (id.length) {
      return response.data.data.data;
    }
  }

  async search(searchValue?: string): Promise<ProductForSelection[]> {
    const key = this.async_url + searchValue;
    if (fetchCache.has(key)) {
      return fetchCache.get(key)!;
    }
    let res;
    if (searchValue) {
      res = await axios.post(this.async_url, [
        {
          field: "naam",
          operator: "like",
          value: searchValue,
        },
      ]);
    } else {
      res = await axios.get(this.async_url);
    }
    fetchCache.set(key, res.data.data.data);
    return res.data.data.data as ProductForSelection[];
  }
}
